<div class="w-full flex flex-col gap-4 p-4">
    <div
        class="w-full flex sm:flex-row flex-col items-center justify-between gap-4"
    >
        <h1 class="text-2xl font-bold">Lista de Email</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Novo Email
        </app-button>
    </div>

    <div
        class="w-full grid lg:grid-cols-[2fr_1fr_1fr_1fr] md:grid-cols-2 grid-cols-1 gap-4 items-end"
    >
        <app-input-search
            label="Filtrar"
            placeholder="Digite algo para pesquisar"
            (keydown.enter)="carregarLista()"
            (search)="carregarLista()"
        ></app-input-search>

        <app-date [(ngModel)]="dataInit"></app-date>

        <app-date [(ngModel)]="dataFim"></app-date>

        <app-date-navigator
            (alterouData)="alterouData($event)"
        ></app-date-navigator>
    </div>

    <p-table
        (onLazyLoad)="lazyLoad($event)"
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [rowsPerPageOptions]="[100, 200, 300, 400, 500, 1000]"
        [totalRecords]="totalItens"
        [value]="lista"
        [lazy]="true"
        dataKey="Id"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[15%] min-w-30">Data Cadastro</th>
                <th class="w-[25%] min-w-40">Assunto</th>
                <th class="w-[40%] min-w-40">Título</th>
                <th class="w-[10%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.DataEnvio | data }}</td>
                <td>{{ rowData.Assunto }}</td>
                <td>{{ rowData.Titulo }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
